const mapWithdrawPage = (data) => {
  const { title, learnMoreText, infoModal, request, restrictions } = data;
  return {
    title,
    learnMoreText,
    infoModal,
    request,
    restrictions
  };
};

export default mapWithdrawPage;
